export default __webpack_public_path__ + "static/media/asl.1275105b.svg";